// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from '@wandb/weave/common/components/elements/Toast';
import {useEffect, useMemo, useRef} from 'react';

import {usePart} from '../../../../state/views/hooks';
import {type Ref as RunSetRef} from '../../../../state/views/runSet/types';
import {RunColorOptions} from '../types';

export const useGrouping = (runsetRef: RunSetRef) => {
  const runSet = usePart(runsetRef);

  const groupSelectionsRef = runSet?.groupSelectionsRef;
  const groupSelections = usePart(groupSelectionsRef);

  return useMemo(
    () => ({
      groupSelections: groupSelections?.grouping,
      hasActiveGrouping:
        groupSelections?.grouping != null &&
        groupSelections.grouping.length > 0,
    }),
    [groupSelections?.grouping]
  );
};

// Exported for testing purposes
export const useGroupingToastNotification = (
  hasActiveGrouping: boolean,
  semanticLegendRunColorOptions: RunColorOptions
) => {
  const hasGroupingChanged = useRef(hasActiveGrouping);
  const haveColorsChanged = useRef<RunColorOptions | boolean>(
    semanticLegendRunColorOptions
  );

  // we don't want to fire any of the toasts on the initial load, it's only after a user starts changing the values that we want to fire the toasts
  useEffect(() => {
    if (hasGroupingChanged.current !== hasActiveGrouping) {
      hasGroupingChanged.current = true;
    }

    const isMetricColors =
      semanticLegendRunColorOptions === RunColorOptions.KeyBasedColors;
    const initialLoadInvalid =
      hasActiveGrouping &&
      !hasGroupingChanged.current &&
      !haveColorsChanged.current &&
      isMetricColors;
    const invalidGroupingChange =
      hasActiveGrouping && hasGroupingChanged.current && isMetricColors;

    if (invalidGroupingChange || initialLoadInvalid) {
      toast('Semantic coloring disabled due to run grouping.');
    }

    if (!hasActiveGrouping && hasGroupingChanged.current && isMetricColors) {
      toast('Grouping removed. Previous semantic coloring restored.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasActiveGrouping]);

  useEffect(() => {
    if (haveColorsChanged.current !== semanticLegendRunColorOptions) {
      haveColorsChanged.current = true;
    }
  }, [semanticLegendRunColorOptions]);
};
